import React from 'react';
import { FadeIn } from './FadeIn';
import { CtaButton } from './CtaButton';
import { Shield, Lock, CreditCard, Star } from '@mui/icons-material';
export function HeroSection() {
  return <section className="relative pt-4 pb-10 px-4 overflow-hidden flex flex-col items-center" data-id="element-129">
      {/* Background elements */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(123,30,58,0.15)_0%,rgba(13,5,5,1)_70%)] pointer-events-none" data-id="element-130" />
      <div className="absolute top-0 left-0 w-full h-full bg-[url('https://www.transparenttextures.com/patterns/stardust.png')] opacity-10 pointer-events-none" data-id="element-131" />

      <div className="max-w-5xl mx-auto w-full relative z-10" data-id="element-132">
        {/* Top section: Title + Image — designed to fit above the fold */}
        <div className="text-center" data-id="element-133">
          <FadeIn delay={0.1} data-id="element-134">
            <div className="flex items-center justify-center gap-2 mb-3" data-id="element-135">
              <span className="w-3 h-4 bg-miel-crimson rounded-sm inline-block" data-id="element-136"></span>
              <h2 className="font-bold tracking-widest text-[#EA3169] uppercase text-[17px]" data-id="element-137">
                MIEL ROJA™
              </h2>
            </div>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-138">
            <h1 className="font-playfair md:text-4xl lg:text-5xl font-bold text-miel-cream mb-1 text-[28px]" data-id="element-139">
              El Protocolo del Retorno.
            </h1>
          </FadeIn>

          {/* Product Image — directly below title */}
          <FadeIn delay={0.3} direction="none" data-id="element-140">
            <div className="relative max-w-xs md:max-w-sm mx-auto mb-4" data-id="element-141">
              <div className="absolute inset-0 bg-miel-gold/15 blur-3xl rounded-full" data-id="element-142" />
              <img src="https://cdn.magicpatterns.com/uploads/airCtxoWcoES6faVc4y6nh/Pone_los_titulos_202604091433.png" alt="Miel Roja - El Protocolo del Retorno" className="relative z-10 w-full max-h-[28vh] object-contain drop-shadow-2xl rounded-lg" data-id="element-143" />
            </div>
          </FadeIn>

          <FadeIn delay={0.4} data-id="element-144">
            <p className="text-base md:text-lg text-miel-gold font-playfair mb-2 italic text-center max-w-2xl mx-auto" data-id="element-145">
              El sistema N°1 de rituales de endulzamiento y retorno amoroso para
              la mujer moderna — Del primer contacto al vínculo blindado
            </p>
          </FadeIn>

          <FadeIn delay={0.45} data-id="element-146">
            <p className="text-miel-cream/90 text-sm md:text-base mb-4 max-w-2xl mx-auto font-medium" data-id="element-147">
              Rituales + Pociones + Conexión emocional + Magia dulce listos para
              ejecutar. Sin buscar. Sin improvisar. Sin pasar otra noche
              llorando sola.
            </p>
          </FadeIn>

          <FadeIn delay={0.5} data-id="element-148">
            <div className="flex flex-wrap justify-center mb-4 max-w-4xl mx-auto gap-[2px]" data-id="element-149">
              <span className="bg-miel-darkest border border-miel-cream/20 px-3 py-1 rounded-full text-xs whitespace-nowrap flex items-center gap-1.5 text-miel-cream font-medium" data-id="element-150">
                📄 100% PDF
              </span>
              <span className="bg-miel-darkest border border-miel-cream/20 px-3 py-1 rounded-full text-xs whitespace-nowrap flex items-center gap-1.5 text-miel-cream font-medium" data-id="element-151">
                ⚡ Acceso en 5 min
              </span>
              <span className="bg-miel-darkest border border-miel-cream/20 px-3 py-1 rounded-full text-xs whitespace-nowrap flex items-center gap-1.5 text-miel-cream font-medium" data-id="element-152">
                🕯️ 2 Tomos completos
              </span>
              <span className="bg-miel-darkest border border-miel-cream/20 px-3 py-1 rounded-full text-xs whitespace-nowrap flex items-center gap-1.5 text-miel-cream font-medium" data-id="element-153">
                🎁 5 Bonos incluidos
              </span>
            </div>
          </FadeIn>

          <FadeIn delay={0.55} data-id="element-154">
            <div className="flex flex-col items-center max-w-2xl mx-auto w-full px-4" data-id="element-155">
              <CtaButton href="#pricing" fullWidth className="mb-4 text-sm md:text-base py-3 px-5" data-id="element-156">
                🔴 → QUIERO MI MIEL ROJA AHORA
              </CtaButton>

              <div className="flex flex-wrap text-[10px] md:text-xs text-miel-cream/70 gap-3 md:gap-5 flex-row items-center justify-center w-full" data-id="element-157">
                <div className="flex items-center gap-1" data-id="element-158">
                  <Shield style={{
                  fontSize: 14
                }} className="text-miel-cream/50" data-id="element-159" />{' '}
                  Garantía 7 días
                </div>
                <div className="flex items-center gap-1" data-id="element-160">
                  <Lock style={{
                  fontSize: 14
                }} className="text-miel-cream/50" data-id="element-161" />{' '}
                  Pago seguro
                </div>
                <div className="flex items-center gap-1" data-id="element-162">
                  <CreditCard style={{
                  fontSize: 14
                }} className="text-miel-cream/50" data-id="element-163" />{' '}
                  Mercado Pago
                </div>
              </div>
            </div>
          </FadeIn>
        </div>

        {/* Stats Row */}
        <FadeIn delay={0.7} direction="up" data-id="element-164">
          <div className="mt-8 border-y border-miel-crimson/20 py-4 flex flex-wrap justify-center gap-6 md:gap-14 text-center bg-miel-darker/50 backdrop-blur-sm" data-id="element-165">
            <div data-id="element-166">
              <div className="text-xl font-playfair font-bold text-miel-gold" data-id="element-167">
                +300
              </div>
              <div className="text-[10px] text-miel-cream/70 uppercase tracking-wider mt-1" data-id="element-168">
                mujeres ya activaron su retorno
              </div>
            </div>
            <div data-id="element-169">
              <div className="text-xl font-playfair font-bold text-miel-gold" data-id="element-170">
                2
              </div>
              <div className="text-[10px] text-miel-cream/70 uppercase tracking-wider mt-1" data-id="element-171">
                Tomos listos
              </div>
            </div>
            <div data-id="element-172">
              <div className="text-xl font-playfair font-bold text-miel-gold" data-id="element-173">
                5
              </div>
              <div className="text-[10px] text-miel-cream/70 uppercase tracking-wider mt-1" data-id="element-174">
                Bonos incluidos
              </div>
            </div>
            <div data-id="element-175">
              <div className="text-xl font-playfair font-bold text-miel-gold flex items-center justify-center gap-1" data-id="element-176">
                4.9/5{' '}
                <Star className="text-miel-gold" style={{
                fontSize: 16
              }} data-id="element-177" />
              </div>
              <div className="text-[10px] text-miel-cream/70 uppercase tracking-wider mt-1" data-id="element-178">
                Calificación
              </div>
            </div>
          </div>
        </FadeIn>

        {/* Initial Testimonials */}
        <div className="mt-8" data-id="element-179">
          <FadeIn data-id="element-180">
            <h3 className="text-center text-sm tracking-widest text-miel-gold uppercase mb-6" data-id="element-181">
              Testimonios Iniciales
            </h3>
          </FadeIn>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-182">
            {[{
            initials: 'MG',
            quote: 'Llevaba 3 semanas sin respuesta. Al tercer día del protocolo me escribió a las 2 AM. No lo podía creer.',
            name: 'Martina G., Córdoba'
          }, {
            initials: 'LP',
            quote: 'El Kit de Mensajes me salvó. Cuando apareció no supe qué decir... pero ahí estaba el script exacto. Respondí con calma y me dijo que quería vernos.',
            name: 'Laura P., Rosario'
          }, {
            initials: 'SC',
            quote: 'Lo hice llorando la primera noche pero igual lo hice. A los 5 días me desbloqueó y a los 7 me llamó. El Protocolo funciona.',
            name: 'Sofía C., Buenos Aires'
          }].map((testimonial, i) => <FadeIn key={i} delay={0.2 * (i + 1)} data-id="element-183">
                <div className="bg-miel-darker border border-miel-crimson/20 p-6 rounded-xl h-full flex flex-col" data-id="element-184">
                  <div className="flex items-center gap-3 mb-4" data-id="element-185">
                    <div className="w-10 h-10 rounded-full bg-miel-crimson flex items-center justify-center font-playfair font-bold text-miel-cream" data-id="element-186">
                      {testimonial.initials}
                    </div>
                    <div className="flex text-miel-gold" data-id="element-187">
                      {[...Array(5)].map((_, j) => <Star key={j} fontSize="small" data-id="element-188" />)}
                    </div>
                  </div>
                  <p className="text-miel-cream/80 italic mb-4 flex-grow" data-id="element-189">
                    "{testimonial.quote}"
                  </p>
                  <p className="text-sm text-miel-goldLight font-semibold" data-id="element-190">
                    — {testimonial.name}
                  </p>
                </div>
              </FadeIn>)}
          </div>
        </div>
      </div>
    </section>;
}